import type { SelfieVerificationSteps } from '../types';

export const STEP_INTRO = 'INTRO';
export const STEP_CONSENT = 'CONSENT';
export const STEP_POSE_VERIFICATION = 'POSE_VERIFICATION';
export const STEP_UNDER_REVIEW = 'UNDER_REVIEW';

export const STEPS_DEFAULT: SelfieVerificationSteps = [
  STEP_INTRO,
  STEP_CONSENT,
  STEP_POSE_VERIFICATION,
  STEP_UNDER_REVIEW,
];

export const ERROR_CONNECTION = 'ERROR_CONNECTION';
